import { Fragment } from "react";
import useQueryParams from "src/hooks/useQueryParams";
import SummaryFinancePage from "./all/SummaryFinancePage";
import ProfitPage from "./profit/ProfitPage";
import ReportPage from "./report/ReportPage";

export default function FinanceManagement() {
  const [option] = useQueryParams();
  return (
    <Fragment>
      {option?.page === "all" && <SummaryFinancePage />}
      {option?.page === "report" && <ReportPage />}
      {option?.page === "profit" && <ProfitPage />}
    </Fragment>
  );
}
